import { LogoutIcon } from "@heroicons/react/solid";
import React, { useEffect, useRef } from "react";
import "./dropdown.css";

function Dropdown({ children, show, setShow, className }) {
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        if (typeof setShow === "function") {
          setShow(false);
        }
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show]);

  if (!show) return null;

  return (
    <>
      <div ref={dropdownRef} className={`dropdown absolute ${className}`}>
        {children}
      </div>
    </>
  );
}

export default Dropdown;
